<i18n>
{
  "en": {
    "createTableQrTitle": "Creating table",
    "editTableQrTitle": "Editing table",
    "emptyFieldError": "Required field",
    "menus": "Menus",
    "saleZone": "SaleZone",
    "linkTree": "Links tree",
    "notValidNumberError": "Invalid type of number",
    "noValidUniqueNumber": "The number is already exist",
    "number": "Table number",
    "useLinkTree": "Use link tree",
    "notValidEmail": "Email is not valid",
    "email": "Email"
  },
  "es": {
    "createTableQrTitle": "Creando una mesa",
    "editTableQrTitle": "Editanto la mesa",
    "emptyFieldError": "Campo obligatorio",
    "menus": "Menus",
    "saleZone":  "SaleZone",
    "linkTree": "Arboles de links",
    "notValidNumberError": "Numero no valido",
    "noValidUniqueNumber": "El numero ya existe",
    "number": "Numero de mesa",
    "useLinkTree": "Utilizar el arbol de links",
    "notValidEmail":  "El email no es valido",
    "email": "Email"
  }
}
</i18n>
<template>
  <v-dialog v-model="visible" max-width="600px" scrollable persistent>
    <v-card v-if="visible" scrollable persistent class="px-7 py-4">
      <v-card-title class="pa-0 mb-2">
        {{ modalTitle }}
      </v-card-title>
      <v-sheet style="background-color: #ffffff">
        <v-form v-model="valid" ref="form">
          <v-text-field :disabled="type === 'edit'" v-model="number" type="number" :rules="numberRules" :label="$t('number')" class="required"/>
          <v-switch v-model="useLinkTree" dense :label="$t('useLinkTree')"/>
          <v-select v-model="menu" :rules="selectRules" :items="menuList" :menu-props="{ maxHeight: '400' }" :label="$t('menus')"
          item-value="guid" item-text="title" class="required"/>
          <v-select v-model="saleZone" :rules="selectRules" :items="saleZoneList" :menu-props="{ maxHeight: '400' }" :label="$t('saleZone')"
          item-value="guid" item-text="name" class="required"/>
          <v-select v-model="linkTree" :items="linkTreeList" :menu-props="{ maxHeight: '400' }" :label="$t('linkTree')"
          item-value="guid" item-text="name"/>
          <v-text-field v-model="email" type="email" :rules="emailRules" :label="$t('email')" class="required"/>
          <dynameat-modal-buttons class="mt-3" @cancel="onCancel" @confirm="onConfirm" :confirmDisabled="!valid"/>
        </v-form>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>
<script>
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import { notNull, notValidNumber, notValidNumberNegative, notValidEmail } from '@core/helpers/formValidators';
import { TableQr } from '../models';

@Component
@Components({
  DynameatModalButtons
})
@MapGetters(['selectedPointOfSale', 'menuList', 'saleZoneList', 'linkTreeList', 'tableNumberList'])
export default class TableQrCreateEditModal extends Vue {
  @Prop({
    Object,
    validator(tableQr) {
      return tableQr instanceof TableQr;
    }
  }) tableQr;

  @Prop({
    String,
    default: 'create',
    validator(type) {
      return type === 'create' || type === 'edit';
    }
  }) type;

  @Prop({ Boolean, default: false }) visible;

  menu = null

  saleZone = null

  linkTree = null

  useLinkTree = false

  valid = false;

  number = null

  email= '';

  clearOwnData() {
    this.valid = false;
    this.menu = null;
    this.saleZone = null;
    this.linkTree = null;
    this.useLinkTree = false;
    this.number = 0;
    this.email = '';
  }

  onCancel() {
    this.clearOwnData();
    this.$emit('cancel');
  }

  onConfirm() {
    if (this.$refs.form.validate()) {
      const tableQrToHandle = new TableQr(this.tableQr?.guid || null, this.selectedPointOfSale.guid,
        this.menu, this.saleZone, this.linkTree, this.useLinkTree, this.number, this.email);
      this.$emit('confirm', tableQrToHandle);
    }
  }

  get modalTitle() {
    return this.$t(`${this.type}TableQrTitle`);
  }

  get numberRules() {
    return [notValidNumber(this.$t('notValidNumberError')), notValidNumberNegative(this.$t('notValidNumberError')), this.noValidUniqueNumber(this.$t('noValidUniqueNumber'))];
  }

  get emailRules() {
    return [notValidEmail(this.$t('notValidEmail'))];
  }

  get selectRules() {
    return [notNull(this.$t('emptyFieldError'))];
  }

  noValidUniqueNumber(errStr = 'Error') {
    return (str) => {
      if (this.type === 'edit') {
        return true;
      }
      return this.tableNumberList.includes(Number(str)) ? errStr : true;
    };
  }

  @Watch('tableQr', { immediate: true })
  onTableQrChanged(newTableQr) {
    if (newTableQr) {
      this.clearOwnData();
      this.number = newTableQr.number !== undefined ? newTableQr.number.toString() : 0;
      this.menu = newTableQr.menu;
      this.saleZone = newTableQr.saleZone;
      this.linkTree = newTableQr.linkTree;
      this.useLinkTree = newTableQr.useLinkTree;
      this.email = newTableQr.email;
    }
  }
}
</script>
